import {
  emptyDocumentHub, emptyFolderDocumentHub, maxMobile, maxTablet, maxWidth,
  primaryColor, primaryHeadingColor, retina, SecondaryColor, secondaryFont, wMBold,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectFoldersPopupVisible } from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import { selectShowUploadDocument } from 'Selector/GlobalSearchContentSelector';

const Wrapper = styled.div`
&.emptyDocHubWrapper {
  &.modelFlag{
   height: auto;
   .empty-heading {
    padding: 180px 0px;
   }
  }
  .empty-document-img {
    height: 405px;
  }
}
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
height: calc(100vh - 221px);
.empty-document-img {
  width: 458px;
  height: 269px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    width: 500px;
    height: 290px;
  }
  @media all and (max-width: ${maxTablet}) {
    width: 412px;
    height: 230px;
  }
  @media all and (max-width: ${maxMobile}) {
    width: 324px;
    height: 190px;
  }
}
.empty-heading {
  .empty-link-folder {
    .add-open {
      margin-left: 6px;
      color: ${SecondaryColor};
    }
  }
  display: flex;
  flex-direction: column;
  color: ${primaryHeadingColor};
  font-family: ${secondaryFont};
  font-size: 22px;
  font-weight: ${wMBold};
  line-height: 33px;
  letter-spacing: -0.796px;
  margin-top: 25px;
  margin-bottom: 0px;
  text-align: center;
  width: 700px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    font-size: 24px;
    line-height: 28px;
    margin-top: 15px;
  }
  @media all and (max-width: ${maxTablet}) {
    font-size: 18px;
    line-height: 20px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 16px;
  }
  &.green-text {
    color: ${primaryColor};
    margin-top: 0px;
    margin-left: 5px;
  }
  &.second {
    margin-top: 0px;
    padding: 180px 0px;
  }
  .add-open {
    color: ${primaryColor};
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
`;

type Props = {
  isSearch: boolean
  emptyDocHub?: boolean
  modelFlag?: boolean
} & typeof defaultProps;
const defaultProps = {
  emptyDocHub: false,
  modelFlag: false,
};
const EmptyStateDocumentHub = function EmptyStateDocumentHub(props: Props) {
  const { isSearch, emptyDocHub, modelFlag } = props;
  const dispatch = useDispatch();
  const foldersPopupVisible = useSelector(selectFoldersPopupVisible);
  const showUploadDocument = useSelector(selectShowUploadDocument);
  const togglePopup = () => {
    dispatch(actions.setDrawerOpen(true));
  };

  return (
    <Wrapper className={classNames('empty-state-document-hub-wrapper', { emptyDocHubWrapper: true, modelFlag })}>
      {isSearch ? null : <img src={emptyDocHub ? emptyFolderDocumentHub : emptyDocumentHub} alt="empty-state-document" className="empty-document-img" />}

      {emptyDocHub ? null : (
        <h1 className="empty-heading">
          {isSearch ? 'No Results Found' : (
            <>
              This folder is empty.
              <br />
              {showUploadDocument
                ? (
                  <span className="empty-link-folder">
                    Start adding files by clicking
                    <span
                      tabIndex={0}
                      role="button"
                      className="add-open"
                      onClick={() => togglePopup()}
                      onKeyPress={() => togglePopup()}
                    >
                      Upload document
                    </span>
                  </span>
                ) : null}
            </>
          )}
        </h1>
      )}
      {emptyDocHub ? (
        <h1 className="empty-heading second">
          Create your own
          personalised folder
        </h1>
      ) : null}
    </Wrapper>
  );
};
EmptyStateDocumentHub.defaultProps = defaultProps;
export default EmptyStateDocumentHub;
